import React from "react";
import Login from "../components/Login/Login";

function Auth({setToken, setUser}) {
  return (
    <div>
      <Login setToken={setToken} setUser={setUser} />
    </div>
  );
}

export default Auth;
